import { Select, SelectItem } from '@heroui/react';
import { FormEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useHospitalFlags from '@/hooks/useHospitalFlags';
import { getStoredLanguage } from '@/localization/utils';

interface LangSelectorProps {
  visible: boolean;
  className?: string;
}

export function LangSelector({ visible, className }: LangSelectorProps) {
  const { i18n, t } = useTranslation('login');
  const [value, setValue] = useState(i18n.language || 'en');
  const { isFrench } = useHospitalFlags();

  const handleSelectionChange = (e: FormEvent) => {
    const target = e.target as HTMLSelectElement;
    setValue(target.value);
  };

  useEffect(() => {
    if (isFrench && !getStoredLanguage()) {
      setValue('fr');
    }
  }, [isFrench]);

  useEffect(() => {
    if (!visible) return;
    i18n.changeLanguage(value);
  }, [value, visible]);

  if (!visible) return null;

  return (
    <Select
      label={t('common.select.language')}
      selectedKeys={[value]}
      className={className}
      onChange={handleSelectionChange}
    >
      <SelectItem key="en">English</SelectItem>
      <SelectItem key="fr">Français</SelectItem>
    </Select>
  );
}
